module.exports = __webpack_public_path__ + "img/opus.8c259e0d.png";